

import React from 'react';
import './Publication.css';

const PublicationData = [
  "環境観測データの統計モデルによるオーロラ出現予測",
  "衛星画像解析によるサンゴ礁モニタリング手法に関する研究",
  "ASTER画像を用いた山口湾・干潟における海面温度およびクロロフィル量の推定",
  "スマートメーターと環境データを利用したビッグデータ解析",
  "衛星データ解析を利用したラオスにおけるマラリア媒介蚊の発生環境条件の分析",
  "衛星データによる竹富島の沿岸環境変化に関するモニタリング手法の研究",
  "住宅地図とリモートセンシングを用いた長門市油谷町における住宅の築年数予測及び精度評価",
  "データ数の仮想的増加のための衛星データフュージョン",
  "英データと基盤地図情報の統合による太陽光パネルの検出モデル",
  "ALOS-2データによる平成30年7月豪雨災害の洪水検知及び洪水ハザードマップの有効性評価",
  "衛星データと統合したセンサノードによる観測とデータ解析手法の開発",
  "阿蘇地方の土砂災害ハザードマップの構築",
  "AR技術を用いた避難支援アプリ開発とその実用性",
  "リモートセンシングおよびGNSSデータを用いた砂浜の環境把握手法の開発",
  "光学衛星画像データを利用した船の検知および精度検証",
  "CNNを用いたオーロラ監視画像の自動分類モデルの構築",
  "ドローン画像を用いたカスケード分類器による漂着ごみの自動検出",
  "Sentinel-2衛星データによる稲の育成モニタリング",
  "自治体における緊急避難場所の評価手法の検討",
  "位置情報ビックデータの活用による移動販売事業の最適化",
  "Costal Vulnerability Assessment of Bsli Province Using Remote Sensing and GIS Approaches",
  "衛星データとUAVデータの段階的代替校正手法の開発",
  "リモートセンシング技術を複合的に利用したインドネシア・メラピ山の時系列変化検出",
  "急傾斜地の土砂災害における衛星データの適用可能性の検討〜2021年7月熱海市土砂災害を事例として",
  "SAR画像と光学画像の補完アルゴリズム開発による土地被覆分類の高頻度化に関する研究",
  "光学衛星画像を用いた低質指標アルゴリズムによる藻場分布図の構築に関する研究",
  "時系列Landσat画像を用いた土地被覆変化によるマレーバクの轢死確率モデルの構築",
  "ドローン画像を用いたCNNによる特定樹種の分類と高度別分類制度の評価",
  "リモートセンシング技術とオープンデータを用いた離島の長期的モニタリング手法の開発",
  "光学衛星画像を用いたカジランガ国立公園における長期的環境レジリエンス評価",
  "コンステレーション衛星画像を用いたウクライナ侵攻における爆撃被害建物の検出手法開発",
  "社会統計データと衛星データを用いたコンパクトシティ評価",
  "宇部市バスロケーションシステムの運行データを活用したバスの遅延解析と対策提案",
  "空中斜め画像を用いた機械学習による太陽光パネルの自動検出",
  "LANDSATを用いた福岡市周辺地域の都市拡大とヒートアイランド現象の関連性評価",
  "セマンティックセグメンテーションと局所コントラストを用いた路面標示の検出及び明度評価",
  "AIを活用した地理的特徴に基づく移動販売の購買行動分析",
  "SAR画像と光学画像の補完アルゴリズム開発による土地被覆分類の高頻度化に関する研究",
  "コンステレーション衛星を用いた底質指標アルゴリズムと現地観測による藻場分布図の構築に関する研究",
];

const Publication = () => {
  return (
    <div className="research-container">
      <h2>Publication</h2>
      {PublicationData.map((title, index) => (
        <p key={index} className="research-title"><br/>{title}</p>

      ))}
    </div>
  );
}

export default  Publication;